module.exports = __webpack_public_path__ + "img/layout-banner.ad5137dd.png";